/* eslint-disable no-unused-vars */
import {
  Box,
  Grid,
  Card,
  Divider,
  TablePagination,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  InputAdornment,
  Tab,
  Tabs,
  Typography,
  Link,
  Avatar,
  useTheme
} from '@mui/material';
import { useCallback, useState, useEffect } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import Scrollbar from '../../Scrollbar';
import useMounted from '../../../hooks/useMounted';
import SearchIcon from '../../../icons/Search';
import moment from 'moment';
import { relaunchApi } from '../../../api/relaunchApi';

const tabs = [
  { label: 'Tous', value: 'all' },
  { label: 'Médecins', value: 'Médecin' },
  { label: 'Infirmiers', value: 'Infirmier' },
  { label: 'Kinés', value: 'Masseur-kinésithérapeute' },
  { label: 'Podologues', value: 'Pédicure-podologue' },
  { label: 'Pharmaciens', value: 'Pharmacien' },
  { label: 'Sages-Femmes', value: 'Sage-Femme' }
];

const callTrackRelanceOptions = [
  { label: 'Tous', value: 'all' },
  { label: 'Sans statut', value: 'empty' },
  { label: 'Pas répondu', value: 'Pas répondu' },
  { label: 'À rappeler', value: 'À rappeler' },
  { label: 'Numéro incorrect', value: 'Numéro incorrect' },
  { label: 'Va se connecter', value: 'Va se connecter' },
  { label: 'Suivi - Téléphone', value: 'Suivi - Téléphone' },
  { label: 'Suivi - Mail', value: 'Suivi - Mail' },
  { label: 'Suivi - SMS', value: 'Suivi - SMS' },
  { label: 'Décalage', value: 'Décalage' },
  { label: 'Annulation', value: 'Annulation' }
];

function stringToColor(string) {
  let hash = 0;
  let i;
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  return color;
}

function stringAvatar(name) {
  if (!name || name.trim().split(' ').length < 2) {
    return {
      sx: {
        bgcolor: '#3b82f6',
      },
      children: 'U'
    };
  }
  const first = name.split(' ')[0][0] || '';
  const last = name.split(' ')[1][0] || '';
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${first}${last}`,
  };
}

const RelaunchLearners = () => {
  const theme = useTheme();
  const mounted = useMounted();
  const { endDateRelaunch, state } = useParams();
  const [page, setPage] = useState(0);
  const [query, setQuery] = useState('');
  const [limit, setLimit] = useState(25);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [learnerRelaunch, setLearnerRelaunch] = useState([]);
  const [currentTab, setCurrentTab] = useState('all');
  const [numberProspects, setNumberProspects] = useState(0);
  const [currentCallTrackRelance, setCurrentCallTrackRelance] = useState('all');
  const [choiceStartDate, setChoiceStartDate] = useState('all');
  const [choiceFormation, setChoiceFormation] = useState('all');
  const [choiceRelance, setChoiceRelance] = useState('all');
  const [formationsInfos, setFormationsInfos] = useState([]);
  const [relanceInfos, setRelanceInfos] = useState([]);
  
  const formationsOptions = [];
  formationsOptions.push({ name: 'Toutes', id: 'all', programNumber: '' });
  formationsInfos.forEach((formation) => {
    formationsOptions.push({ name: formation.name, id: formation.id, programNumber: formation.program_number });
  });
  
  let choiceStartDateOptions = [];
  const [sessionsStartDate, setSessionsStartDate] = useState([]);

  const relanceOptions = [];
  relanceOptions.push({ name: 'Tous', id: 'all' });
  relanceInfos.forEach((person) => {
    relanceOptions.push({ name: `${person.firstname} ${person.lastname}`, id: person.id });
  });

  const getRelaunchInfo = useCallback(async () => {
    try {
      const data = await relaunchApi.getRelaunchLearner(endDateRelaunch, state, localStorage.getItem('accessToken'), '', 'all', 'all', 'all', 'all', 'all', page, limit);
      if (mounted.current) {
        setLearnerRelaunch(data.customers);
        setNumberProspects(data.numberCustomers.number);
        setFormationsInfos(data.formations);
        setSessionsStartDate(data.startDates);
        setRelanceInfos(data.relance);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted, endDateRelaunch, state, page, limit]);

  useEffect(() => {
    getRelaunchInfo();
  }, [getRelaunchInfo]);

  choiceStartDateOptions = [{ label: 'Toutes', value: 'all' }];
  sessionsStartDate.forEach((item) => choiceStartDateOptions.push({ label: moment(item.start_date).format('DD/MM/YYYY'), value: item.start_date }));

  const [callTrackRelance, setCallTrackRelance] = useState({
    empty: null,
    'Pas répondu': null,
    'À rappeler': null,
    'Numéro incorrect': null,
    'Va se connecter': null,
    Annulation: null,
    'Suivi - Téléphone': null,
    'Suivi - Mail': null,
    'Suivi - SMS': null,
    Décalage: null,
  });

  const [filters, setFilters] = useState({
    Médecin: null,
    Infirmier: null,
    'Masseur-kinésithérapeute': null,
    'Pédicure-podologue': null,
    Pharmacien: null,
    'Sage-Femme': null
  });

  const handleCustomers = useCallback(async (querySearch, callTrackRelaunchChange, startSessionsChange, formationChange, relaunchChange, tabProfession, pageChoice, limitChoice) => {
    try {
      const data = await relaunchApi.getRelaunchLearner(endDateRelaunch, state, localStorage.getItem('accessToken'), querySearch, callTrackRelaunchChange, startSessionsChange, formationChange, relaunchChange, tabProfession, pageChoice, limitChoice);
      setLearnerRelaunch(data.customers);
      setNumberProspects(data.numberCustomers.number);
    } catch (err) {
      console.error(err);
    }
  }, [endDateRelaunch, state]);

  const handleQueryChange = (event) => {
    setQuery(event.target.value);
    if (event.target.value.length >= 3) {
      handleCustomers(event.target.value, callTrackRelance, choiceStartDate, choiceFormation, choiceRelance, filters, page, limit);
    }
    if (event.target.value.length === 0) {
      handleCustomers('', callTrackRelance, choiceStartDate, choiceFormation, choiceRelance, filters, page, limit);
    }
    setPage(0);
  };

  const handleChangeStartDate = (event) => {
    setChoiceStartDate(event.target.value);
    handleCustomers(query, callTrackRelance, event.target.value, choiceFormation, choiceRelance, filters, page, limit);
    setPage(0);
  };

  const handleChangeOptionFormation = (event) => {
    setChoiceFormation(event.target.value);
    handleCustomers(query, callTrackRelance, choiceStartDate, event.target.value, choiceRelance, filters, page, limit);
    setPage(0);
  };

  const handleChangeOptionRelance = (event) => {
    setChoiceRelance(event.target.value);
    handleCustomers(query, callTrackRelance, choiceStartDate, choiceFormation, event.target.value, filters, page, limit);
    setPage(0);
  };

  const handleTabsChange = (event, value) => {
    const updatedFilters = {
      ...filters,
      Médecin: null,
      Infirmier: null,
      'Masseur-kinésithérapeute': null,
      'Pédicure-podologue': null,
      Pharmacien: null,
      'Sage-Femme': null
    };

    if (value !== 'all') {
      updatedFilters[value] = true;
    }

    setFilters(value);
    setSelectedCustomers([]);
    setCurrentTab(value);
    setPage(0);
    handleCustomers(query, callTrackRelance, choiceStartDate, choiceFormation, choiceRelance, value, page, limit);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    handleCustomers(query, callTrackRelance, choiceStartDate, choiceFormation, choiceRelance, filters, newPage, limit);
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
    handleCustomers(query, callTrackRelance, choiceStartDate, choiceFormation, choiceRelance, filters, page, parseInt(event.target.value, 10));
  };

  const handleCallTrackRelanceChange = (event, value) => {
    const updatedCallTrackRelance = {
      ...callTrackRelance,
      empty: null,
      'Pas répondu': null,
      'À rappeler': null,
      'Numéro incorrect': null,
      'Va se connecter': null,
      Annulation: null,
      'Suivi - Téléphone': null,
      'Suivi - Mail': null,
      'Suivi - SMS': null,
      Décalage: null,
    };

    let targetValue = 'all';
    if (typeof event.target === 'undefined') {
      if (value !== 'all') {
        updatedCallTrackRelance[value] = true;
      }
      setCallTrackRelance(updatedCallTrackRelance);
      setSelectedCustomers([]);
      setCurrentCallTrackRelance(value);
      targetValue = value;
    } else {
      if (event.target.value !== 'all') {
        updatedCallTrackRelance[event.target.value] = true;
      }
      setCallTrackRelance(event.target.value);
      setSelectedCustomers([]);
      setCurrentCallTrackRelance(event.target.value);
      window.localStorage.setItem('choiceCallTrackRelance', JSON.stringify(event.target.value));
      targetValue = event.target.value;
    }
    setPage(0);
    handleCustomers(query, targetValue, choiceStartDate, choiceFormation, choiceRelance, filters, page, limit);
  };

  return (
    <Box sx={{ py: 1 }}>
      <Card
        sx={{
          borderRadius: '24px',
          border: '1px solid',
          borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.05)',
          background: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 0.65)' : 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.02)',
          overflow: 'hidden'
        }}
      >
        <Tabs
          indicatorColor="primary"
          onChange={handleTabsChange}
          scrollButtons="auto"
          textColor="primary"
          value={currentTab}
          variant="scrollable"
          sx={{
            mx: 3,
            my: 2.5,
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(241, 245, 249, 0.8)' : 'rgba(30, 41, 59, 0.5)',
            backdropFilter: 'blur(8px)',
            borderRadius: '16px',
            p: 0.5,
            border: '1px solid',
            borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.05)',
            minHeight: 'auto',
            '& .MuiTabs-indicator': {
              height: '100%',
              borderRadius: '12px',
              backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.08)',
              boxShadow: theme.palette.mode === 'light' ? '0 4px 12px rgba(0, 0, 0, 0.05)' : 'none',
              border: theme.palette.mode === 'light' ? 'none' : '1px solid rgba(255, 255, 255, 0.1)',
            },
            '& .MuiTab-root': {
              fontWeight: 700,
              fontSize: '0.85rem',
              textTransform: 'none',
              minWidth: 90,
              minHeight: 40,
              py: 1,
              px: 2.5,
              borderRadius: '12px',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              zIndex: 1,
              color: 'text.secondary',
              '&.Mui-selected': {
                color: 'primary.main',
              },
              '&:hover': {
                color: 'primary.main',
                opacity: 0.9,
                transform: 'translateY(-1px)'
              }
            }
          }}
        >
          {tabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
        
        <Box sx={{ p: 3, display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center', bgcolor: theme.palette.mode === 'light' ? 'rgba(248, 250, 252, 0.4)' : 'rgba(15, 23, 42, 0.2)' }}>
          <Box sx={{ flexGrow: 1, minWidth: 260 }}>
            <TextField
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ color: 'text.secondary', mr: 1 }}>
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
                sx: { borderRadius: '12px' }
              }}
              onChange={handleQueryChange}
              placeholder="Chercher un apprenant..."
              value={query}
              variant="outlined"
              size="small"
            />
          </Box>
          <Box sx={{ minWidth: 180 }}>
            <TextField
              fullWidth
              label="Statut d'appel"
              name="callTrackRelance"
              onChange={handleCallTrackRelanceChange}
              select
              SelectProps={{ native: true }}
              value={currentCallTrackRelance}
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              InputProps={{ sx: { borderRadius: '12px' } }}
            >
              {callTrackRelanceOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
          </Box>
          <Box sx={{ minWidth: 180 }}>
            <TextField
              fullWidth
              label="Date de début"
              name="choice"
              onChange={handleChangeStartDate}
              select
              SelectProps={{ native: true }}
              value={choiceStartDate}
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              InputProps={{ sx: { borderRadius: '12px' } }}
            >
              {choiceStartDateOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
          </Box>
          <Box sx={{ minWidth: 180 }}>
            <TextField
              fullWidth
              label="Formation"
              name="formation"
              onChange={handleChangeOptionFormation}
              select
              SelectProps={{ native: true }}
              value={choiceFormation}
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              InputProps={{ sx: { borderRadius: '12px' } }}
            >
              {formationsOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name} {option.programNumber}
                </option>
              ))}
            </TextField>
          </Box>
          <Box sx={{ minWidth: 180 }}>
            <TextField
              fullWidth
              label="Assigné à"
              name="relance"
              onChange={handleChangeOptionRelance}
              select
              SelectProps={{ native: true }}
              value={choiceRelance}
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              InputProps={{ sx: { borderRadius: '12px' } }}
            >
              {relanceOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
            </TextField>
          </Box>
        </Box>
        
        <Scrollbar>
          <Box sx={{ minWidth: 1000, px: 2, py: 1 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700, color: 'text.secondary', borderBottom: `1px solid ${theme.palette.divider}` }}>Nom Prénom</TableCell>
                  <TableCell sx={{ fontWeight: 700, color: 'text.secondary', borderBottom: `1px solid ${theme.palette.divider}` }}>Profession</TableCell>
                  <TableCell sx={{ fontWeight: 700, color: 'text.secondary', borderBottom: `1px solid ${theme.palette.divider}` }}>Statut</TableCell>
                  <TableCell sx={{ fontWeight: 700, color: 'text.secondary', width: 340, borderBottom: `1px solid ${theme.palette.divider}` }}>N° de session, début, formation</TableCell>
                  <TableCell sx={{ fontWeight: 700, color: 'text.secondary', borderBottom: `1px solid ${theme.palette.divider}` }}>Dernier commentaire</TableCell>
                  <TableCell sx={{ fontWeight: 700, color: 'text.secondary', borderBottom: `1px solid ${theme.palette.divider}` }}>Relance</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {learnerRelaunch.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 6, color: 'text.secondary', fontStyle: 'italic' }}>
                      Aucun apprenant correspondant aux filtres
                    </TableCell>
                  </TableRow>
                ) : (
                  learnerRelaunch.map((link) => (
                    <TableRow
                      key={link.id}
                      sx={{
                        borderBottom: theme.palette.mode === 'light' ? '1px solid #f1f5f9' : '1px solid rgba(255, 255, 255, 0.03)',
                        '&:hover': { bgcolor: theme.palette.mode === 'light' ? 'rgba(241, 245, 249, 0.4)' : 'rgba(255, 255, 255, 0.01)' }
                      }}
                    >
                      <TableCell sx={{ py: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                          <Avatar
                            src={link.avatar}
                            sx={{ height: 42, width: 42, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', fontWeight: 700 }}
                            {...stringAvatar(`${(link.firstname || '').replace(/ /g, '')} ${(link.lastname || '').replace(/ /g, '')}`)}
                          />
                          <Link
                            component={RouterLink}
                            to={`/dashboard/customers/${link.id}`}
                            sx={{
                              textDecoration: 'none',
                              fontWeight: 750,
                              fontSize: '0.85rem',
                              color: link.treated === 1 ? 'success.main' : 'primary.main',
                              '&:hover': { color: link.treated === 1 ? 'success.dark' : 'primary.dark' }
                            }}
                          >
                            {link.firstname} {link.lastname}
                          </Link>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ fontSize: '0.85rem', fontWeight: 500, color: 'text.secondary' }}>
                        {link.profession}
                      </TableCell>
                      <TableCell sx={{ fontSize: '0.85rem' }}>
                        <Box
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            px: 1.5,
                            py: 0.5,
                            borderRadius: '12px',
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            backgroundColor: theme.palette.mode === 'light' ? 'rgba(59, 130, 246, 0.08)' : 'rgba(59, 130, 246, 0.15)',
                            color: 'primary.main'
                          }}
                        >
                          {link.qualification || 'Non qualifié'}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography sx={{ whiteSpace: 'pre-line', fontSize: '0.8rem', lineHeight: 1.6 }}>
                          {link.formations.map((formation) => (
                            <Link
                              key={`${formation.session_id}-${formation.number_session}`}
                              component={RouterLink}
                              to={`/dashboard/session/${formation.session_id}`}
                              sx={{
                                display: 'block',
                                color: 'text.primary',
                                textDecoration: 'none',
                                fontWeight: 600,
                                '&:hover': { color: 'primary.main', textDecoration: 'underline' }
                              }}
                            >
                              {`Session ${formation.number_session} • ${moment(formation.start_date).format('DD/MM/YYYY')} • ${formation.name.length > 40 ? `${formation.name.slice(0, 40)}...` : formation.name}`}
                            </Link>
                          ))}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ fontSize: '0.8rem', color: 'text.secondary', fontWeight: 500, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {link.comment || 'Aucun commentaire.'}
                      </TableCell>
                      <TableCell sx={{ fontSize: '0.85rem', fontWeight: 700, color: 'text.primary' }}>
                        {link.firstnameRelauncher} {link.lastnameRelauncher}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Box>
        </Scrollbar>
        <TablePagination
          component="div"
          count={numberProspects}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[15, 25, 50]}
          sx={{ borderTop: `1px solid ${theme.palette.divider}` }}
        />
      </Card>
    </Box>
  );
};

export default RelaunchLearners;
